import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="transfer-projects--filter"
export default class extends Controller {
  static targets = ["form", "yearSelect", "toYear"];

  connect() {
    this.filterByYear(undefined, { submit: false });
  }

  filterByYear(event, options={ submit: true }) {
    const year = this.yearSelectTarget?.value;

    if (!year) {
      this.toYearTarget.value = "";
      return;
    }

    this.toYearTarget.value = `${parseInt(year, 10) + 1}年度`;
    if (options.submit) this.formTarget.requestSubmit();
  }
}
